// client/src/components/admin/EditAssetModal.js
import React from 'react';
import { Edit, X } from 'lucide-react';

function EditAssetModal({
  editingAsset,
  setEditingAsset,
  handleEditAsset,
  setShowEditAssetModal,
}) {
  if (!editingAsset) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-gray-800">
            <Edit size={20} className="inline mr-2" /> Edit Asset
          </h3>
          <button onClick={() => setShowEditAssetModal(false)} className="text-gray-500 hover:text-red-500">
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleEditAsset}>
          <div className="responsive-grid">
            
            {/* IMEI (Read Only - Identity) */}
            <div className="form-group">
              <label>IMEI (Cannot be changed)</label>
              <input 
                type="text" 
                className="input-field input-disabled"
                value={editingAsset.IMEI || ""}
                readOnly
              />
            </div>

            {/* Model */}
            <div className="form-group">
              <label>Model Name</label>
              <input 
                type="text" 
                className="input-field"
                value={editingAsset.model || ""}
                onChange={(e) => setEditingAsset({ ...editingAsset, model: e.target.value })}
                required
              />
            </div>

            {/* Serial Number */}
            <div className="form-group">
              <label>Serial Number</label>
              <input 
                type="text" 
                className="input-field"
                value={editingAsset.serialNumber || ""}
                onChange={(e) => setEditingAsset({ ...editingAsset, serialNumber: e.target.value })}
              />
            </div>

            {/* ASSET TYPE - STRICT DROPDOWN */}
            {/* Yaha "Bike" ya "Car" nahi aana chahiye, sirf hardware type aayega */}
            <div className="form-group">
              <label>Asset Type (Hardware)</label>
              <select 
                className="input-field"
                value={editingAsset.type || "hardwire"}
                onChange={(e) => setEditingAsset({ ...editingAsset, type: e.target.value })}
              >
                <option value="hardwire">Hardwire (Wired)</option>
                <option value="portable">Portable (Wireless)</option>
                <option value="OBD">OBD (Plug & Play)</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Status */}
            <div className="form-group">
              <label>Status</label>
              <select 
                className="input-field"
                value={editingAsset.status || "unassigned"}
                onChange={(e) => setEditingAsset({ ...editingAsset, status: e.target.value })}
              >
                <option value="unassigned">Unassigned</option>
                <option value="assigned">Assigned</option>
                <option value="faulty">Faulty</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>

            {/* Purchase Date */}
            <div className="form-group">
              <label>Purchase Date</label>
              <input 
                type="date" 
                className="input-field"
                value={editingAsset.purchaseDate ? new Date(editingAsset.purchaseDate).toISOString().split('T')[0] : ""}
                onChange={(e) => setEditingAsset({ ...editingAsset, purchaseDate: e.target.value })}
              />
            </div>

            {/* --- SIM CARD SECTION --- */}
            <div className="form-group col-span-full border-t pt-4 mt-2">
              <h4 className="font-semibold text-gray-700 mb-2">SIM Card Details</h4>
            </div>

            <div className="form-group">
              <label>Provider (Operator)</label>
              <input 
                type="text" 
                className="input-field"
                placeholder="e.g. Airtel, Jio"
                value={editingAsset.simCard?.provider || ""}
                onChange={(e) => setEditingAsset({ 
                  ...editingAsset, 
                  simCard: { ...editingAsset.simCard, provider: e.target.value } 
                })}
              />
            </div>

            <div className="form-group">
              <label>MSDN (Mobile No)</label>
              <input 
                type="text" 
                className="input-field"
                value={editingAsset.simCard?.MSDN || ""}
                onChange={(e) => setEditingAsset({ 
                  ...editingAsset, 
                  simCard: { ...editingAsset.simCard, MSDN: e.target.value } 
                })}
              />
            </div>

            <div className="form-group">
              <label>IMSI</label>
              <input 
                type="text" 
                className="input-field"
                value={editingAsset.simCard?.IMSI || ""}
                onChange={(e) => setEditingAsset({ 
                  ...editingAsset, 
                  simCard: { ...editingAsset.simCard, IMSI: e.target.value } 
                })}
              />
            </div>

            <div className="form-group">
              <label>SIM Expiry Date</label>
              <input 
                type="date" 
                className="input-field"
                value={editingAsset.simCard?.expiryDate ? new Date(editingAsset.simCard.expiryDate).toISOString().split('T')[0] : ""}
                onChange={(e) => setEditingAsset({ 
                  ...editingAsset, 
                  simCard: { ...editingAsset.simCard, expiryDate: e.target.value } 
                })}
              />
            </div>

            {/* Notes */}
            <div className="form-group col-span-full">
              <label>Notes</label>
              <textarea 
                className="input-field"
                rows="2"
                value={editingAsset.notes || ""}
                onChange={(e) => setEditingAsset({ ...editingAsset, notes: e.target.value })}
              ></textarea>
            </div>

          </div>

          <div className="button-group-center mt-6">
            <button type="submit" className="btn-primary">
              Update Asset
            </button>
            <button type="button" className="btn-secondary" onClick={() => setShowEditAssetModal(false)}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditAssetModal;